module.exports = __webpack_public_path__ + "img/icon-no-salary-data.19ea6eb.svg";